import { useDispatch, useSelector } from 'react-redux';
import { actionSetRoutes } from '../data/action';

export const DASHBOARD_ROUTER_ID = "Dashboard"

export const setRoutes = (dispatch, id, routes) => dispatch(actionSetRoutes(id, routes))
export const getRoutes = ({routes}, id) => routes[id] || [];
export const setDashboardRoutes = (dispatch, routes) => setRoutes(dispatch, DASHBOARD_ROUTER_ID, routes)
export const getDashboardRoutes = (state)=> getRoutes(state, DASHBOARD_ROUTER_ID)

export const useDashboardAdditionalRoutes = ()=>{
    const routes = useSelector(state =>{
        return getDashboardRoutes(state)
    } )
    const dispatch = useDispatch()
    return [
        routes,
        (newRoutesList) => setDashboardRoutes( dispatch, newRoutesList) 
    ]
}